import { ThemesPage } from './Themes';
import { Route, Routes } from 'react-router-dom';

export const ThemeRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<ThemesPage />} />
    </Routes>
  );
};
